// roleColors.ts
export const USERS_COLORS: Record<string, string> = {
  "project manager": "role-blue",
  "project viewer": "role-green",
  "super user": "role-pink",
  "admin": "role-purple",
};
